<template>
  <spinner-container :loading="localLoading">
    <back-btn />
    <v-container fluid>
      <v-card class="card--shadow">
        <v-card-text>
          <div class="d-flex justify-space-between">
            <div>
              <h2
                class="subtitle-1 font-weight-bold grey--text"
                v-if="volunteer"
              >
                {{ volunteer.code }}/{{ volunteer.name }}
              </h2>
            </div>
            <div>
              <h2 class="subtitle-1 font-weight-bold grey--text">
                Month: {{ $route.query.month }} / Year: {{ $route.query.year }}
              </h2>
            </div>
            <div>
              <export-vol-detail
                :volunteer="volunteer"
                :volDetail="generatedData"
              />
            </div>
          </div>

          <div
            class="d-flex justify-end"
            v-show="$route.params.month && $route.params.year"
          >
            <!-- <export-monthly :datas="generatedData" /> -->
          </div>
        </v-card-text>
        <v-simple-table fixed-header height="100vh">
          <template>
            <thead>
              <tr>
                <th class="text-left">Sr No</th>
                <th class="text-left">အစီရင်ခံမည့်အချက်အလက်များ</th>
                <th class="text-left">Male</th>
                <th class="text-left">Female</th>
                <th class="text-left">Total</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in generatedData" :key="index">
                <td>{{ item.counter }}</td>
                <td>{{ item.title }}</td>
                <td :class="{ black_box: item.data.female == null }">
                  {{ item.data.male }}
                </td>
                <td :class="{ black_box: item.data.male == null }">
                  {{ item.data.female }}
                </td>
                <td
                  @click="getDotsPatient(item)"
                  v-if="item.data.female != null && item.data.male != null"
                >
                  {{ Number(item.data.male) + Number(item.data.female) }}
                </td>
                <td @click="getDotsPatient()" v-else>
                  {{ item.data }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <!-- Dots paitent modal -->
        <dots-patient :dialog="dialog" @closeDialog="dialog = !dialog" />
      </v-card>
    </v-container>
  </spinner-container>
</template>

<script>
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer.vue";
import BackBtn from "@/components/navigation/BackBtn.vue";
import ExportVolDetail from "@/components/report/volunteer/ExportVolDetail.vue";
import DotsPatient from "@/components/report/modal/DotsPatient.vue";

export default {
  components: { SpinnerContainer, BackBtn, ExportVolDetail, DotsPatient },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapState("Loading", ["localLoading"]),
    ...mapState("Report", ["volDetail"]),
    ...mapState("Volunteer", ["volunteer"]),
    generatedData() {
      var data = [];
      var counter = 0;
      if (!this.loading) {
        Object.entries(this.volDetail).forEach(([key, value]) => {
          counter++;
          data.push({
            counter: counter,
            data: value,
            title: key,
          });
        });
      }
      return data;
    },
  },
  methods: {
    getDotsPatient(item) {
      let params = {
        month: this.$route.query.month,
        year: this.$route.query.year,
        volunteer_id: this.$route.query.id,
      };
      this.dialog = !this.dialog;
      if (item.counter == 1)
        this.$store.dispatch("DotsVolunteer/getDotsPatients", params);
      else this.$store.dispatch("DotsVolunteer/getDotsFinishPatients", params);
    },
  },
  created() {
    let params = {
      month: this.$route.query.month,
      year: this.$route.query.year,
      volunteer_id: this.$route.query.id,
    };
    params.is_dots_report = this.$route.query.is_dots_report ? true : "";

    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store
      .dispatch("Volunteer/getVolunteer", this.$route.query.id)
      .then(() => {
        this.$store.dispatch("Loading/changeLocalLoading");
        this.$store.dispatch("Report/getVolDetail", params);
      });
  },
};
</script>

<style scoped>
.black_box {
  background: #181313;
  border: 1px solid #353131;
}
</style>


